export const GET_JOB_POSITION_WATCHER = 'GET_JOB_POSITION_WATCHER';
export const GET_JOB_POSITION_SUCCESS = 'GET_JOB_POSITION_SUCCESS';
export const GET_JOB_POSITION_FAILED = 'GET_JOB_POSITION_FAILED';
